import { Component, OnChanges, Input, SimpleChanges, Injector } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ApAlertService, ApNotificationService, ApUndoableOperationService } from 'webcommon/core-ui';
import { FcListValidationService } from '../../generic/fc-list-validation/fc-list-validation.service';
import { FcItemModalContext } from '../../../models';
import { FcPharmacyClearinghouseListItemDto, FormGroupValidationRules } from 'webcommon/shared';
import { FcItemListBaseComponent, FormGroupExtended } from '../../generic';

@Component({
    providers: [ApAlertService, FcListValidationService],
    selector: 'fc-pharmacy-clearinghouse-manage-pharmacy-tab',
    templateUrl: './fc-pharmacy-clearinghouse-manage-pharmacy-tab.component.html',
    styleUrls: ['./fc-pharmacy-clearinghouse-manage-pharmacy-tab.component.less'],
})
export class FcPharmacyManagePharmacyTabComponent extends FcItemListBaseComponent implements OnChanges {
    @Input() baseId: string;
    @Input() form: FormGroupExtended;
    @Input() listItem: FcPharmacyClearinghouseListItemDto;
    @Input() isSubmitted = false;
    @Input() itemContext: FcItemModalContext;

    // Form Controls
    public areaCodesControl: FormControl = new FormControl('');
    public zipCodesControl: FormControl = new FormControl('');
    public pharmacyIdsControl: FormControl = new FormControl('');
    public importMailOrderPharmaciesControl: FormControl = new FormControl(true);
    public disableEPrescribeControl: FormControl = new FormControl(false);

    public listItemDefaultValidation: FormGroupValidationRules = {
        AreaCodes: {
            MaxLength: 32768,
        },
        ZipCodes: {
            MaxLength: 32768,
        },
        PharmacyIds: {
            MaxLength: 32768,
        },
    };

    constructor(
        injector: Injector,
        protected apUndoableOperationService: ApUndoableOperationService,
        public apNotificationService: ApNotificationService) {
        super(injector);
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.itemContext != null) {
            this.fcListValidation.initValidation(this.itemContext, this.listItemDefaultValidation);
        }
        if (changes.form != null) {
            this.addControlsToForm();
        }
        if (changes.itemContext != null || changes.form != null || changes.listItem != null) {
            this.setForm();
        }
    }

    private addControlsToForm(): void {
        this.form.addControl('areaCodes', this.areaCodesControl);
        this.form.addControl('zipCodes', this.zipCodesControl);
        this.form.addControl('pharmacyIds', this.pharmacyIdsControl);
        this.form.addControl('importMailOrderPharmacies', this.importMailOrderPharmaciesControl);
        this.form.addControl('disableEPrescribe', this.disableEPrescribeControl);
    }

    public setForm(): void {
        // Disable ePrescribe For Fax Only Pharmacies Control
        this.disableEPrescribeControl.setValue(this.listItem.InactivateFaxOnly);
    }
}
